import styled from "@emotion/styled";

export const MDSPanelContainer = styled.div`
  width: 100%;
  height: 100%;
`;
